import { createContext, useContext } from "react";
import type { ActiveInputComponent } from "../transport";

export interface GenUIInputContextValue {
  /** The interactive component currently awaiting the user, or null. */
  activeInput: ActiveInputComponent | null;
  /** Surface an interactive component (called by the transport side channel). */
  showInput: (component: ActiveInputComponent) => void;
  /** Remove the active interactive component. */
  dismissInput: () => void;
}

export const GenUIInputContext = createContext<GenUIInputContextValue | null>(null);

const NOOP_INPUT: GenUIInputContextValue = {
  activeInput: null,
  showInput: () => {},
  dismissInput: () => {},
};

/**
 * Access the active-input side channel. Outside an `AgentProvider` this degrades to
 * an inert no-op (no active input), so components like `SidePanel` still render.
 */
export function useGenUIInput(): GenUIInputContextValue {
  return useContext(GenUIInputContext) ?? NOOP_INPUT;
}
